<!-- https://cssloaders.github.io/ -->

<script lang="ts">
  import type { Content } from "$lib/elev8Api/contentTypes";
  import { logger } from "$lib/utils/logger";
  import { SOURCE_VERSION } from "virtual:source-version";
  interface Props {
    content?: Content;
    displayId?: string;
    msg?: string;
  }
  const { content: _, displayId, msg }: Props = $props(); // content prop to match factory interface but unused.

  logger.info("[LoadingContent] VERSION:", SOURCE_VERSION);
  //NOTE: LayoutTheme CSS variables and defaults may or may not be available (as they are set in SpotController).
</script>

<div class="wrapper"><span class="loader"></span></div>
<div class="source-version">
  <div>ID: {displayId} | v.{SOURCE_VERSION?.slice(0, 7) ?? "?"}</div>
  {#if msg}
    <div>{msg}</div>
  {/if}
</div>

<style>
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background-color: #fff;
  }

  .loader {
    width: 48px;
    height: 48px;
    border: 5px solid #282c34;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .source-version {
    position: absolute;
    margin: 0.2em 0.6em;
    right: 0;
    bottom: 0;
    font-family: monospace;
    font-size: 0.95vw;
    color: #acaeb1;
  }
</style>
